const sraRouter = [
  {
      path: "list-sra",
      name: "sra",
      component: () => import("@/views/admin/sra"),
      default: true,
      meta: {
          model: "sra",
          // requiresAuth: true,
      },
  },
  {
      path: "list-sra/add",
      name: "addSra",
      component: () => import("@/views/admin/sra/function"),
      default: true,
      meta: {
          model: "sra",
          // requiresAuth: true,
      },
  },
  {
      path: "list-sra/edit/:id",
      name: "editSra",
      component: () => import("@/views/admin/sra/function"),
      default: true,
      meta: {
          model: "sra",
          // requiresAuth: true,
      },
  },
  {
    path: "list-sra/view/:id",
    name: "detailSra",
    component: () => import("@/views/admin/sra/view"),
    default: true,
    meta: {
        model: "sra",
        // requiresAuth: true,
    },
  },
    {
        path: "list-sra/detail/:id",
        name: "detailSraData",
        component: () => import("@/views/admin/sra/detail"),
        default: true,
        meta: {
            model: "sra",
            // requiresAuth: true,
        },
    },
    {
        path: "list-sra/details/:id",
        name: "detailsSra",
        component: () => import("@/views/admin/sra/details"),
        default: true,
        meta: {
            model: "sra",
            // requiresAuth: true,
        },
    },
    // {
    //     path: "evaluation-form/detail/:id",
    //     name: "detailEvaluationForm",
    //     component: () => import("@/views/admin/evaluation_form/detail"),
    //     default: true,
    //     meta: {
    //         model: "evaluation_form",
    //         // requiresAuth: true,
    //     },
    // }
]
export default sraRouter;